<!-- 会员详情 -->
<template>
<div class="mMemberDetails">
    <div class="memberTypeBox">
        <div class="memberType">
            <div class="memberCard yearCard">
                <div class="userInfo">
                    <img :src="memberDetails.islogin ? (user.logourl ? user.logourl : require('@/common/images/memberDetails/default_head_picture.png')) : require('@/common/images/memberDetails/default_head_picture.png')" class="headPicture" alt="">
                    <div class="tips" v-if="!memberDetails.islogin" @click="handleGoLogin">登录后查看会员状态</div>
                    <div class="name" v-if="memberDetails.islogin">{{ user.name }}</div>
                </div>
                <div class="cardName">蓝鲸会员年卡</div>
                <div class="openTips" v-if="!memberDetails.islogin || memberDetails.status === 0 || memberDetails.zjmemtype === 1">开通会员，即刻享受更多权益</div>
                <div class="openTips" v-else-if="memberDetails.zjmemtype === 2 && memberDetails.status === 99">当前年卡会员已过期，请续费</div>
                <div class="openTips" v-else-if="memberDetails.zjmemtype === 2 && memberDetails.status === 1">有效期至 {{memberDetails.expiredate}}</div>
                <div class="btn" v-if="!memberDetails.islogin || memberDetails.status === 99 || memberDetails.status === 0" @click="handleUploadCustomerFeeOrder(2)">立即开通</div>
                <div class="btn" v-if="memberDetails.zjmemtype === 1 && memberDetails.status === 1" @click="handleUploadCustomerFeeOrder(2)">升级年卡</div>
                <div class="btn" v-if="memberDetails.zjmemtype === 2 && memberDetails.status === 1" @click="handleUploadCustomerFeeOrder(2)">马上续费</div>
            </div>
            <div class="memberCard plusCard">
                <div class="userInfo">
                    <img :src="memberDetails.islogin ? (user.logourl ? user.logourl : require('@/common/images/memberDetails/default_head_picture.png')) : require('@/common/images/memberDetails/default_head_picture.png')" class="headPicture" alt="">
                    <div class="tips" v-if="!memberDetails.islogin" @click="handleGoLogin">登录后查看会员状态</div>
                    <div class="name" v-if="memberDetails.islogin">{{ user.name }}</div>
                </div>
                <div class="cardName">蓝鲸会PLUS卡</div>
                <div class="openTips" v-if="!memberDetails.islogin || memberDetails.status === 0 || (memberDetails.zjmemtype === 2 && memberDetails.status === 99)">开通会员，即刻享受更多权益</div>
                <div class="openTips" v-else-if="memberDetails.zjmemtype === 1 && memberDetails.status === 99">当前PLUS卡已过期，请续费</div>
                <div class="openTips" v-else-if="memberDetails.zjmemtype === 1 && memberDetails.status === 1">有效期至 {{memberDetails.expiredate}}</div>
                <div class="openTips" v-else-if="memberDetails.zjmemtype === 2 && memberDetails.status === 1">当前已享有会员最高权益</div>
                <div class="btn" v-if="!memberDetails.islogin || memberDetails.status === 99 || memberDetails.status === 0" @click="handleUploadCustomerFeeOrder(1)">立即开通</div>
                <div class="btn" v-if="memberDetails.zjmemtype === 1 && memberDetails.status === 1" @click="handleUploadCustomerFeeOrder(1)">马上续费</div>
            </div>
        </div>
    </div>
    <div class="moduleTitle">会员介绍</div>
    <div class="memberIntroduce">
        <div class="title">资鲸网蓝鲸会</div>
        <div class="info">资鲸网，以创新、创投、创业、创富为核心关键词，为投行、券商、律所、VC/PE等行业从业者、企业创始人、泛金融从业者以及新型企投家，提供专业的投资与创业学习成长内容。</div>
        <div class="introduceBox">
            <div class="introduceItem">
                <img :src="require('@/common/images/memberDetails/introduce_item_icon1.png')" class="introduceItemIcon" alt="">
                <div class="itemIntro">
                    <div>最前沿的创投知识</div>
                    <div>开阔眼界放大格局</div>
                </div>
                <div class="label">创新</div>
            </div>
            <div class="introduceItem">
                <img :src="require('@/common/images/memberDetails/introduce_item_icon2.png')" class="introduceItemIcon" alt="">
                <div class="itemIntro">
                    <div>最专业的投资干货</div>
                    <div>掌握投资底层逻辑</div>
                </div>
                <div class="label">创投</div>
            </div>
            <div class="introduceItem">
                <img :src="require('@/common/images/memberDetails/introduce_item_icon3.png')" class="introduceItemIcon" alt="">
                <div class="itemIntro">
                    <div>最实战的创业技能</div>
                    <div>从零到一不走弯路</div>
                </div>
                <div class="label">创业</div>
            </div>
            <div class="introduceItem">
                <img :src="require('@/common/images/memberDetails/introduce_item_icon4.png')" class="introduceItemIcon" alt="">
                <div class="itemIntro">
                    <div>最实操的财富密码</div>
                    <div>提升风险抵御能力</div>
                </div>
                <div class="label">创富</div>
            </div>
        </div>
        <div class="title">蓝鲸会四维一体服务</div>
        <div class="fourServe">
            <div class="serveItem">
                <div class="itemTitle">三大专业板块内容</div>
                <div class="itemContent">投资、创业、理财，三大系统专业板块内容，陪伴创投每一步</div>
            </div>
            <div class="serveItem">
                <div class="itemTitle">前沿热点随时跟进</div>
                <div class="itemContent">持续上线最新课程，随时随地跟进学习最新最热的前沿赛道</div>
            </div>
            <div class="serveItem">
                <div class="itemTitle">专享会员互动社群</div>
                <div class="itemContent">随时随地与各行业精英沟通学习，交流观点看法，扩展认知边界</div>
            </div>
            <div class="serveItem">
                <div class="itemTitle">顶级投资人言传身教</div>
                <div class="itemContent">头部机构顶级投资人，结合自身投资经验及行业趋势，分享实战经验方法</div>
            </div>
            <div class="logoBox">
                <img :src="require('@/common/images/memberDetails/logo.png')" class="logo" alt="">
            </div>
        </div>
    </div>
    <div class="moduleTitle">会员权益</div>
    <div class="memberPower">
        <div class="tips">诚邀国内头部机构行业精英担任导师，共同打磨课程，将投资逻辑、已验证的投资决策和盘托出，为你呈现既有深度又有广度的高价值内容。</div>
        <div class="powerTable">
            <div class="row row1">
                <div class="name yearName">蓝鲸会年卡</div>
                <div class="name plusName">蓝鲸会PLUS卡</div>
            </div>
            <div class="row row2">
                <div class="price yearPrice">{{memberDetails.yearprice}}元<span class="unit">/年</span></div>
                <div class="price plusPrice">{{memberDetails.plusprice}}元<span class="unit">/年</span></div>
            </div>
            <div class="row row3">
                <div class="power yearPower">
                    <div class="powerItemBox">
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                <span>3000+</span>分钟课程时长免费学
                            </div>
                        </div>
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                <span>13000+</span>免费行业精品报告
                            </div>
                        </div>
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                <span>80+</span>业内实战授课老师
                            </div>
                        </div>
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                5*12小时专属客服
                            </div>
                        </div>
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                VIP会员专属活动
                            </div>
                        </div>
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                创投沙龙活动
                            </div>
                        </div>
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                最新研报及部分课程PPT
                            </div>
                        </div>
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                折扣购买其他付费课程
                            </div>
                        </div>
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/year_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                推荐好友加入领取月度资料集
                            </div>
                        </div>
                    </div>
                    <div class="btnBox">
                        <div class="btn" v-if="!memberDetails.islogin || memberDetails.zjmemtype === 0 || memberDetails.status === 99" @click="handleUploadCustomerFeeOrder(2)">立即开通</div>
                        <div class="btn" v-if=" memberDetails.zjmemtype === 1 && memberDetails.status === 1" @click="handleUploadCustomerFeeOrder(2)">升级年卡</div>
                        <div class="btn" v-if=" memberDetails.zjmemtype === 2 && memberDetails.status === 1" @click="handleUploadCustomerFeeOrder(2)">马上续费</div>
                    </div>
                </div>
                <div class="power plusPower">
                    <div class="powerItemBox">
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/plus_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                <span>1000+</span>免费行业精品报告
                            </div>
                        </div>
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/plus_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                5*12小时专属客服
                            </div>
                        </div>
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/plus_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                VIP会员专属活动
                            </div>
                        </div>
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/plus_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                最新研报及部分课程PPT
                            </div>
                        </div>
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/plus_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                折扣购买其他付费课程
                            </div>
                        </div>
                        <div class="powerItem">
                            <img :src="require('@/common/images/memberDetails/plus_power.png')" class="icon" alt="">
                            <div class="itemValue">
                                推荐好友加入领取月度资料集
                            </div>
                        </div>
                    </div>
                    <div class="btnBox">
                        <div class="btn" v-if="!memberDetails.islogin || memberDetails.zjmemtype === 0 || memberDetails.status === 99" @click="handleUploadCustomerFeeOrder(1)">立即开通</div>
                        <div class="btn" v-if="memberDetails.zjmemtype === 1 && memberDetails.status === 1" @click="handleUploadCustomerFeeOrder(1)">马上续费</div>
                        <div class="btn disabled" v-if="memberDetails.zjmemtype === 2 && memberDetails.status === 1" @click="handleUploadCustomerFeeOrder(1)">马上续费</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="moduleTitle">常见问题</div>
    <div class="questionItemBox">
        <div class="questionItem">
            <div class="question">
                <div class="label">问</div>
                <div class="value">购买会员后可以学习哪些内容和下载哪些资料？</div>
            </div>
            <div class="answer">
                <div class="label">答</div>
                <div class="value">蓝鲸会员在资鲸网，可无限次学习资鲸网自研课程和下载会员资料包。</div>
            </div>
        </div>
        <div class="questionItem">
            <div class="question">
                <div class="label">问</div>
                <div class="value">在哪学习，学习形式是怎样？</div>
            </div>
            <div class="answer">
                <div class="label">答</div>
                <div class="value">开通账号后在资鲸网、资鲸网APP、资鲸订阅号​学习。</div>
            </div>
        </div>
        <div class="questionItem">
            <div class="question">
                <div class="label">问</div>
                <div class="value">课程和资料会迭代更新吗？</div>
            </div>
            <div class="answer">
                <div class="label">答</div>
                <div class="value">课程和资料包全年持续更新，请留意会员群消息。</div>
            </div>
        </div>
        <div class="questionItem">
            <div class="question">
                <div class="label">问</div>
                <div class="value">可以开具发票报销吗？</div>
            </div>
            <div class="answer">
                <div class="label">答</div>
                <div class="value">购买蓝鲸会员及资鲸网课程如果需要开具发票，请联系客服索要正规发票。</div>
            </div>
        </div>
        <div class="questionItem">
            <div class="question">
                <div class="label">问</div>
                <div class="value">购买会员/课程后可以退款吗？</div>
            </div>
            <div class="answer">
                <div class="label">答</div>
                <div class="value">会员/课程服务为虚拟服务，一旦开启，课程权益即刻开放，所以不支持中途退款，请谨慎选择！</div>
            </div>
        </div>
    </div>
    <div class="moduleTitle">联系我们</div>
    <div class="linkUsBox">
        <div class="linkUs">
            <div>咨询热线：0755-86393160 13066904312（微信同号）</div>
            <div>联系邮箱：info@capwhale.com</div>
            <div>会员管理秘书：zijing361</div>
            <div>公司地址：深圳市南山区​粤兴二道6号武汉大学深圳产学研大楼A601-I</div>
        </div>
    </div>
    <div class="memberPrivilege" v-if="courseTotal">
        <div class="titleMore">
            <div class="title">会员课程（{{courseTotal}}）</div>
            <div class="more" @click="handleGoMoreCourse">更多></div>
        </div>
        <div class="itemBox">
            <div class="item" @click="handleGoCourseDetails(item)" v-for="(item, index) in courseList" :key="index">
                <img :src="item.coverurl" class="coverurl" alt="">
                <div class="subject">{{ item.subject }}</div>
            </div>
        </div>
    </div>
    <div class="memberPrivilege" v-if="reportTotal">
        <div class="titleMore">
            <div class="title">会员报告（{{reportTotal}}）</div>
            <div class="more" @click="handleGoMoreReport">更多></div>
        </div>
        <div class="itemBox">
            <div class="item" @click="handleGoReportDetails(item)" v-for="(item, index) in reportList" :key="index">
                <img :src="item.coverurl" class="coverurl" alt="">
                <div class="subject">{{ item.subject }}</div>
            </div>
        </div>
    </div>
    <van-popup v-model:show="showOpenMemberSuccess" class="openMemberSuccessDialog">
        <div class="openSuccessTips">
            <div class="tips">
                <div>恭喜您</div>
                <div>成功开通蓝鲸会员{{ ordertype === 62 ? 'PLUS卡' : '年卡' }}</div>
            </div>
            <div class="expiredate">有效期至 {{ expiredate }}</div>
            <div class="closeBtn" @click="showOpenMemberSuccess = false">好的，知道了</div>
        </div>
    </van-popup>
</div>
</template>

<script>
import {queryCustomerFeeInfo, uploadCustomerFeeOrder, queryCustomerFeeOrderPayResult} from '@/api/memberDetails.js'
import {getCustomerInfo} from '@/api/api.js'
import {getSearchResult} from '@/api/reportApi.js'
import {mapGetters, mapActions} from 'vuex'
export default {
    data() {
        return {
            memberDetails: {},
            courseList: [],
            courseTotal: 0,
            reportList: [],
            reportTotal: 0,
            showOpenMemberSuccess: false,
            expiredate: '',
            ordertype: 0
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if(!this.domainInfo.isMobile){
            if (this.$route.query.orderno && this.$route.query.rid && this.$route.query.result && this.$route.query.sign) {
                this.$router.push({
                    name: 'MemberDetails',
                    query: {
                        chid: this.$route.query.chid ? this.$route.query.chid : ''
                    },
                    params: {
                        orderno: this.$route.query.orderno,
                        rid: this.$route.query.rid,
                        result: this.$route.query.result,
                        sign: this.$route.query.sign
                    }
                })
            } else {
                this.$router.push({
                    name: 'MemberDetails',
                    query: {chid: this.$route.query.chid ? this.$route.query.chid : ''}
                })
            }
        } else {
            if (this.$route.query.orderno && this.$route.query.rid && this.$route.query.result && this.$route.query.sign) {
                this.$router.push({
                    name: 'MMemberDetails',
                    replace: true,
                    params: {
                        orderno: this.$route.query.orderno,
                        rid: this.$route.query.rid,
                        result: this.$route.query.result,
                        sign: this.$route.query.sign
                    }
                })
            }
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        if (this.$route.params.orderno && this.$route.params.rid && this.$route.params.result && this.$route.params.sign) {
            this.handleQueryCustomerFeeOrderPayResult()
        } else {
            this.handleQueryCustomerFeeInfo()
        }
        this.handleGetSearchResult({
            key: '',
            catecode: '',
            catecode2: '',
            coursetype: '',
            feetype: '',
            kmctype: 7,
            page: 1,
            pageSize: 4,
            couponinnerid: '',
            voucherdistype: '',
            zjmemtype: 1
        })
        this.handleGetSearchResult({
            key: '',
            catecode: '',
            catecode2: '',
            reportyear: '',
            feetype: '',
            hostid: '',
            kmctype: 2,
            page: 1,
            pageSize: 4,
            zjmemtype: 1
        })
    },
    methods: {
        handleQueryCustomerFeeOrderPayResult() {
            let params = {
                orderno: this.$route.params.orderno,
                result: this.$route.params.result,
                rid: this.$route.params.rid,
                sign: this.$route.params.sign,
                ispaysuccess: 1
            }
            this.setLoading(true)
            queryCustomerFeeOrderPayResult({
                data: params,
                success: res => {
                    this.setLoading(false)
                    // res.data.status = 30
                    this.expiredate = res.data.orderexpiredate
                    this.ordertype = res.data.ordertype
                    if (res.data.status === 30) {
                        if (res.data.logintoken) {
                            let user = {
                                loginToken: res.data.logintoken ? res.data.logintoken : ''
                            }
                            window.sessionStorage.setItem('user', JSON.stringify(user))
                            this.setUser(user)
                        }
                        if (this.user.isLogin && res.data.islogin && this.user.loginToken === res.data.logintoken) {
                            this.showOpenMemberSuccess = true
                            this.handleQueryCustomerFeeInfo()
                        } else if (res.data.islogin) {
                            this.setLoading(true)
                            getCustomerInfo({
                                data: {},
                                success: data => {
                                    this.setLoading(false)
                                    let user = {
                                        innerid: data.data.innerid ? data.data.innerid : '',
                                        isperfect: data.data.isperfect ? data.data.isperfect : '',
                                        loginToken: data.data.loginToken ? data.data.loginToken : '',
                                        loginname: data.data.loginname ? data.data.loginname : '',
                                        logourl: data.data.logourl ? data.data.logourl : '',
                                        mobile: data.data.mobile ? data.data.mobile : '',
                                        name: data.data.name ? data.data.name : '',
                                        nickname: data.data.nickname ? data.data.nickname : '',
                                        promoterid: data.data.promoterid ? data.data.promoterid : '',
                                        isLogin: data.data.innerid ? true : false,
                                        zjmemtype: data.data.zjmemtype ? data.data.zjmemtype : 0
                                    }
                                    window.sessionStorage.setItem('user', JSON.stringify(user))
                                    this.setUser(user)
                                    this._setCookie('token', user.loginToken)
                                    this.showOpenMemberSuccess = true
                                },
                                error: res => {
                                    this.setLoading(false)
                                    this.$message.error(res.msg)
                                    this.handleQueryCustomerFeeInfo()
                                }
                            })
                        } else {
                            this.handleQueryCustomerFeeInfo()
                        }
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.handleQueryCustomerFeeInfo()
                    // this.$message.error(res.msg)
                }
            })
        },
        _setCookie(key, value, expiredays) {
            let exdate = new Date();
            exdate.setDate(exdate.getDate() + expiredays);
            document.cookie = key + '=' + value
            + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
            + ';path=/'
            + ';domain=' + window.location.hostname.split('.').slice(-2).join('.');
        },
        handleQueryCustomerFeeInfo() {
            this.setLoading(true)
            queryCustomerFeeInfo({
                data: {},
                success: res => {
                    this.setLoading(false)
                    // res.data.status = 1
                    // res.data.expiredate = '2024年08月01日'
                    this.memberDetails = res.data
                    if (!this.memberDetails.islogin && this.user.isLogin) {
                        window.sessionStorage.clear()
                        let user = {
                            innerid: '',
                            loginToken: '',
                            loginname: '',
                            logourl: '',
                            mobile: '',
                            name: '',
                            nickname: '',
                            isLogin: false,
                            zjmemtype: 0
                        }
                        this.setUser(user)
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        handleGetSearchResult(params) {
            this.setLoading(true)
            getSearchResult({
                data: params,
                success: res => {
                    this.setLoading(false)
                    if (params.kmctype === 7) {
                        this.courseList = res.data.courselist
                        this.courseTotal = res.data.pageinfo.rowCount
                    } else if (params.kmctype === 2) {
                        this.reportList = res.data.reportlist
                        this.reportTotal = res.data.pageinfo.rowCount
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        // 去课程详情
        handleGoCourseDetails(item) {
            this.$router.push({name: 'MCourseView', query: {cid: item.innerid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
        },
        handleGoMoreCourse() {
            this.$router.push({name: 'MSearchList', query: {screentype: '3'}})
        },
        // 去报告详情
        handleGoReportDetails(item) {
            this.$router.push({name: 'MReportDetails', query: {reportid: item.innerid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
        },
        handleGoMoreReport() {
            this.$router.push({name: 'MReportSearch', query: {feetype: '3'}})
        },
        handleGoLogin() {
            this.$router.push({name: 'MLogin'})
        },
        handleUploadCustomerFeeOrder(zjmemtype) {
            if (!this.memberDetails.islogin) {
                this.setLoginPop(true)
            } else {
                let params = {
                    zjmemtype,
                    ordermoney: zjmemtype === 1 ? this.memberDetails.plusprice : this.memberDetails.yearprice,
                    resulturl: location.href
                }
                this.setLoading(true)
                uploadCustomerFeeOrder({
                    data: params,
                    success: res => {
                        this.setLoading(false)
                        window.location.replace(res.data.url)
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        ...mapActions([
            'setLoading',
            'setUser'
        ])
    },
    watch: {
        user: function(newVal, oldVal) {
            if (newVal != oldVal && newVal.innerid) {
                this.handleQueryCustomerFeeInfo()
            }
        }
    },
    computed: {
        ...mapGetters([
            'user',
            'domainInfo'
        ])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.mMemberDetails {
    background: #fff;
    padding-bottom: 0.08rem;
    height: 100vh;
    box-sizing: border-box;
    // overflow-y: scroll;
    .memberTypeBox {
        height: 3.46rem;
        overflow: hidden;
        padding-top: 0.28rem;
        .memberType {
            height: 4rem;
            display: flex;
            overflow-x: scroll;
            padding: 0 0.32rem 0;
            box-sizing: border-box;
            .memberCard {
                width: 6.48rem;
                height: 3.46rem;
                min-width: 6.48rem;
                padding-left: 0.4rem;
                padding-top: 0.7rem;
                box-sizing: border-box;
                &.yearCard {
                    margin-right: 0.2rem;
                    background: url('../../../common/images/memberDetails/year_member_card_mobile.png') no-repeat;
                    background-size: 100% 100%;
                    .btn {
                        width: 2.08rem;
                        height: 0.52rem;
                        background: linear-gradient(116deg, #23BDFF 0%, #2383FF 100%);
                        box-shadow: inset 0px 0px 0.06rem 0px rgba(171,240,255,0.8), 0px 0.04rem 0.04rem 0px rgba(0,0,0,0.25);
                        text-align: center;
                        line-height: 0.52rem;
                        border-radius: 1rem;
                        color: #fff;
                        margin-top: 0.28rem;
                    }
                }
                &.plusCard {
                    background: url('../../../common/images/memberDetails/plus_member_card_mobile.png') no-repeat;
                    background-size: 100% 100%;
                    .btn {
                        width: 2.08rem;
                        height: 0.52rem;
                        background: linear-gradient(115deg, #C7C7C7 0%, #818FA1 100%);
                        box-shadow: inset 0px 0.04rem 0.04rem 0px #D9D9D9, 0px 0px 0.06rem 0px rgba(0,0,0,0.25);
                        text-align: center;
                        line-height: 0.52rem;
                        border-radius: 1rem;
                        color: #fff;
                        margin-top: 0.28rem;
                    }
                }
                .userInfo {
                    display: flex;
                    align-items: center;
                    margin-bottom: 0.2rem;
                    .headPicture {
                        width: 0.6rem;
                        height: 0.6rem;
                        margin-right: 0.1rem;
                        border-radius: 50%;
                    }
                    .tips {
                        font-size: 0.24rem;
                        color: #fff;
                        text-decoration: underline;
                    }
                    .name {
                        font-size: 0.24rem;
                        color: #FFFFFF;
                    }
                }
                .cardName {
                    font-size: 0.32rem;
                    color: #fff;
                    font-weight: bold;
                    line-height: 0.38rem;
                    margin-bottom: 0.1rem;
                }
                .openTips {
                    font-size: 0.18rem;
                    color: #fff;
                    line-height: 0.22rem;
                }
            }
        }
    }
    .moduleTitle {
        width: 3.14rem;
        height: 0.5rem;
        background: url('../../../common/images/memberDetails/title_bg.png') no-repeat;
        background-size: 100% 100%;
        margin: 0.4rem auto;
        text-align: center;
        line-height: 0.5rem;
        font-size: 0.36rem;
        color: #333333;
        font-weight: bold;
    }
    .memberIntroduce {
        padding: 0 0.32rem;
        box-sizing: border-box;
        .title {
            font-size: 0.32rem;
            color: #333333;
            line-height: 0.38rem;
            font-weight: bold;
            text-align: center;
            margin-bottom: 0.32rem;
        }
        .info {
            font-size: 0.28rem;
            color: #333333;
            line-height: 0.34rem;
            text-indent: 0.56rem;
            margin-bottom: 0.24rem;
        }
        .introduceBox {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-bottom: 0.2rem;
            .introduceItem {
                width: 3.33rem;
                height: 4.23rem;
                margin-bottom: 0.2rem;
                background: url('../../../common/images/memberDetails/introduce_item_bg.png') no-repeat;
                background-size: 100% 100%;
                text-align: center;
                padding-top: 0.3rem;
                box-sizing: border-box;
                .introduceItemIcon {
                    width: 1.1rem;
                    height: 1.1rem;
                    margin: 0 auto 0.46rem;
                }
                .itemIntro {
                    font-size: 0.28rem;
                    color: #fff;
                    line-height: 0.42rem;
                    margin-bottom: 0.6rem;
                }
                .label {
                    font-size: 0.32rem;
                    color: #fff;
                    line-height: 0.38rem;
                    font-weight: bold;
                }
            }
        }
        .fourServe {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            position: relative;
            .serveItem {
                width: 3.24rem;
                height: 2.18rem;
                padding: 0.2rem;
                box-sizing: border-box;
                background: #F5F5F5;
                margin-bottom: 0.2rem;
                padding-right: 0.8rem;
                &:nth-of-type(3), &:nth-of-type(4) {
                    margin-bottom: 0rem;
                }
                &:nth-of-type(2n) {
                    padding-left: 0.76rem;
                    padding-right: 0.12rem;
                }
                .itemTitle {
                    font-size: 0.26rem;
                    color: #333333;
                    margin-bottom: 0.18rem;
                    font-weight: bold;
                }
                .itemContent {
                    font-size: 0.24rem;
                    color: #333333;
                    line-height: 0.34rem;
                }
            }
            .logoBox {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                width: 1.64rem;
                height: 1.64rem;
                border: 0.1rem solid #ffffff;
                box-sizing: border-box;
                background: #519AF4;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                .logo {
                    width: 0.8rem;
                    height: 0.56rem;
                }
            }
        }
    }
    .memberPower {
        padding: 0 0.32rem;
        box-sizing: border-box;
        .tips {
            font-size: 0.28rem;
            color: #333333;
            line-height: 0.34rem;
            margin-bottom: 0.4rem;
            text-indent: 0.56rem;
        }
        .powerTable {
            .row {
                display: flex;
                align-items: stretch;
                &.row1 {
                    .name {
                        flex: 1;
                        height: 0.68rem;
                        font-size: 0.28rem;
                        text-align: center;
                        line-height: 0.68rem;
                        font-weight: bold;
                        &.yearName {
                            background: linear-gradient(180deg, #6FA0FF 0%, #2A51A3 100%);
                            color: #ffffff;
                        }
                        &.plusName {
                            background: linear-gradient(180deg, #707886 0%, #3D434E 100%);
                            color: #FFE0AF;
                        }
                    }
                }
                &.row2 {
                    .price {
                        height: 0.8rem;
                        flex: 1;
                        line-height: 0.8rem;
                        text-align: center;
                        font-size: 0.28rem;
                        color: #FF6666;
                        box-sizing: border-box;
                        font-weight: bold;
                        .unit {
                            font-size: 0.24rem;
                            font-weight: bold;
                        }
                        &.yearPrice {
                            border: 0.02rem solid #1464C8;
                            border-bottom-color: #CADFEE;
                        }
                        &.plusPrice {
                            border: 0.02rem solid #434A55;
                            border-bottom-color: #CADFEE;
                        }
                    }
                }
                &.row3 {
                    .power {
                        flex: 1;
                        height: 6.16rem;
                        padding: 0.3rem 0.2rem;
                        box-sizing: border-box;
                        .powerItemBox {
                            height: 4.92rem;
                            .powerItem {
                                display: flex;
                                align-items: center;
                                margin-bottom: 0.25rem;
                                .icon {
                                    width: 0.2rem;
                                    height: 0.2rem;
                                    margin-right: 0.15rem;
                                }
                                .itemValue {
                                    font-size: 0.2rem;
                                    color: #333333;
                                    font-weight: bold;
                                    line-height: 0.24rem;
                                    span {
                                        font-weight: bold;
                                        color: #FF6666;
                                    }
                                }
                            }
                        }
                        &.yearPower {
                            border: 0.02rem solid #1464C8;
                            border-top: none;
                        }
                        &.plusPower {
                            border: 0.02rem solid #434A55;
                            border-top: none;
                        }
                        .btnBox {
                            .btn {
                                width: 2.7rem;
                                height: 0.54rem;
                                border-radius: 0 0.1rem 0 0.1rem;
                                box-shadow: 0px 0.06rem 0.12rem 0px rgba(188,45,25,0.6);
                                background: #F95050;
                                text-align: center;
                                line-height: 0.54rem;
                                color: #fff;
                                font-size: 0.24rem;
                                font-weight: bold;
                                margin: 0 auto;
                                &.disabled {
                                    background: #CCCCCC;
                                    box-shadow: 0px 0.06rem 0.08rem 0px rgba(180,180,180,0.4);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .questionItemBox {
        padding: 0 0.32rem;
        box-sizing: border-box;
        .questionItem {
            padding: 0.32rem 0.2rem;
            box-sizing: border-box;
            box-shadow: 0px 0px 0.06rem 0px rgba(0,0,0,0.15);
            &:not(:last-of-type) {
                margin-bottom: 0.28rem;
            }
            .question {
                display: flex;
                align-items: flex-start;
                margin-bottom: 0.2rem;
                line-height: 0.34rem;
                .label {
                    width: 0.28rem;
                    height: 0.28rem;
                    min-width: 0.28rem;
                    min-height: 0.28rem;
                    background: #FF6666;
                    text-align: center;
                    line-height: 0.28rem;
                    margin-right: 0.08rem;
                    color: #fff;
                    font-size: 0.2rem;
                    position: relative;
                    top: 0.02rem;
                }
                .value {
                    font-size: 0.28rem;
                    color: #FF6666;
                    font-weight: bold;
                    line-height: 0.4rem;
                }
            }
            .answer {
                display: flex;
                align-items: flex-start;
                line-height: 0.34rem;
                .label {
                    width: 0.28rem;
                    height: 0.28rem;
                    min-width: 0.28rem;
                    min-height: 0.28rem;
                    background: #1464C8;
                    text-align: center;
                    line-height: 0.28rem;
                    margin-right: 0.08rem;
                    color: #fff;
                    font-size: 0.2rem;
                    position: relative;
                    top: 0.04rem;
                }
                .value {
                    font-size: 0.28rem;
                    color: #333333;
                    line-height: 0.4rem;
                }
            }
        }
    }
    .linkUsBox {
        padding: 0 0.32rem;
        box-sizing: border-box;
        .linkUs {
            padding: 0.32rem 0.2rem;
            box-shadow: 0px 0px 0.06rem 0px rgba(0,0,0,0.15);
            font-size: 0.28rem;
            color: #333333;
            line-height: 0.48rem;
            margin-bottom: 0.4rem;
        }
    }
    .memberPrivilege {
        padding: 0 0.32rem;
        box-sizing: border-box;
        .titleMore {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0.2rem;
            .title {
                font-size: 0.28rem;
                color: #333333;
                font-weight: bold;
                display: flex;
                align-items: center;
                &::before {
                    content: '';
                    display: block;
                    width: 0.04rem;
                    height: 0.28rem;
                    background: #1464C8;
                    margin-right: 0.1rem;
                }
            }
            .more {
                font-size: 0.24rem;
                color: #999999;
            }
        }
        .itemBox {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .item {
                width: 3.27rem;
                height: 2.42rem;
                box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.2);
                border-radius: 10px 10px 10px 10px;
                overflow: hidden;
                margin-bottom: 0.32rem;
                .coverurl {
                    width: 3.27rem;
                    height: 1.84rem;
                }
                .subject {
                    padding: 0.12rem 0.16rem;
                    box-sizing: border-box;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 0.24rem;
                    color: #333333;
                    line-height: 0.28rem;
                }
            }
        }
    }
    .openMemberSuccessDialog {
        width: 7.48rem;
        height: 7.9rem;
        background: url('../../../common/images/memberDetails/open_member_success_mobile.png') no-repeat;
        background-size: 100% 100%;
        padding-top: 3.3rem;
        box-sizing: border-box;
        top: 40%;
        .openSuccessTips {
            width: 4.8rem;
            height: 4.2rem;
            background: #fff;
            border-radius: 0.1rem;
            margin: 0 auto;
            padding: 0.56rem 0.54rem;
            box-sizing: border-box;
            text-align: center;
            .tips {
                font-size: 0.32rem;
                color: #FF6666;
                line-height: 0.52rem;
                margin-bottom: 0.2rem;
                div {
                    font-weight: bold;
                }
            }
            .expiredate {
                font-size: 0.24rem;
                color: #333333;
                line-height: 0.52rem;
                margin-bottom: 0.6rem;
            }
            .closeBtn {
                width: 3.48rem;
                height: 0.68rem;
                border-radius: 1rem;
                background: #FCAE54;
                color: #fff;
                font-size: 0.28rem;
                line-height: 0.68rem;
                margin: 0 auto;
            }
        }
    }
}
</style>